/* ============================================================
   LULL BRANDS — theme.js
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  // ── CUSTOM CURSOR ────────────────────────────────────────
  const cur  = document.getElementById('lull-cursor');
  const curR = document.getElementById('lull-cursor-ring');
  if (cur && curR && window.innerWidth > 768) {
    let mx=0,my=0,rx=0,ry=0;
    document.addEventListener('mousemove', e => {
      mx=e.clientX; my=e.clientY;
      cur.style.left=mx+'px'; cur.style.top=my+'px';
    });
    (function anim(){
      rx+=(mx-rx)*.1; ry+=(my-ry)*.1;
      curR.style.left=rx+'px'; curR.style.top=ry+'px';
      requestAnimationFrame(anim);
    })();
    document.querySelectorAll('a,button,.ing-card,.how-card,.bundle-card,.stat-card,.testimonial-card,.subscribe-row,.pack-btn,.email-input,.cta-email-input').forEach(el=>{
      el.addEventListener('mouseenter',()=>document.body.classList.add('cursor-hover'));
      el.addEventListener('mouseleave',()=>document.body.classList.remove('cursor-hover'));
    });
  }

  // ── NAV SCROLL ───────────────────────────────────────────
  const siteHeader = document.getElementById('site-header');
  const ctaBanner  = document.getElementById('cta');
  if (siteHeader) {
    window.addEventListener('scroll', () => {
      siteHeader.classList.toggle('scrolled', window.scrollY > 50);
      if (ctaBanner) {
        const r = ctaBanner.getBoundingClientRect();
        document.body.classList.toggle('cursor-inv', r.top < window.innerHeight && r.bottom > 0);
      }
    }, { passive: true });
  }

  // ── SCROLL REVEAL ────────────────────────────────────────
  const ro = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); });
  }, { threshold: 0.08 });
  document.querySelectorAll('.reveal').forEach(el => ro.observe(el));

  // ── HERO PARALLAX ────────────────────────────────────────
  const heroBg = document.querySelector('.hero__bg');
  if (heroBg) {
    window.addEventListener('scroll', () => {
      heroBg.style.transform = `translateY(${window.scrollY * 0.18}px)`;
    }, { passive: true });
  }

  // ── PACK SELECTOR ────────────────────────────────────────
  let currentBasePrice = 4.29;

  window.setPack = function(btn, price, sub) {
    document.querySelectorAll('.pack-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    currentBasePrice = parseFloat(price);
    const priceEl = document.getElementById('product-price-main');
    const subEl   = document.getElementById('product-price-sub');
    if (priceEl) priceEl.textContent = '$' + currentBasePrice.toFixed(2);
    if (subEl)   subEl.textContent   = sub;
  };

  // ── TESTIMONIAL SLIDER ───────────────────────────────────
  let tOffset = 0;
  const tTrack = document.getElementById('testimonials-track');
  window.slideTestimonials = function(dir) {
    if (!tTrack) return;
    const cardW = tTrack.querySelector('.testimonial-card')?.offsetWidth || 348;
    const gap = 18;
    const max = (tTrack.children.length - 2) * (cardW + gap);
    tOffset = Math.max(0, Math.min(max, tOffset + dir * (cardW + gap)));
    tTrack.style.transform = `translateX(-${tOffset}px)`;
  };

  // ── SMOOTH SCROLL ────────────────────────────────────────
  // Smart nav — scroll if on homepage, navigate home+anchor if on subpage
  window.navTo = function(anchor) {
    if (window.location.pathname === '/' || window.location.pathname === '') {
      const el = document.querySelector(anchor);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      window.location.href = '/' + anchor;
    }
  };

  window.scrollToSection = function(selector) {
    document.querySelector(selector)?.scrollIntoView({ behavior: 'smooth' });
  };

  // ── NOTIFICATION TOAST ───────────────────────────────────
  let notifTimer;
  window.showNotification = function(msg) {
    const n = document.getElementById('lull-notification');
    if (!n) return;
    n.textContent = msg;
    n.classList.add('show');
    clearTimeout(notifTimer);
    notifTimer = setTimeout(() => n.classList.remove('show'), 2800);
  };

  // ── MODAL ────────────────────────────────────────────────
  window.openSignupModal = function() {
    const overlay = document.getElementById('signup-modal');
    const inner   = document.getElementById('signup-modal-inner');
    if (!overlay) return;
    overlay.classList.add('open');
    if (inner) inner.style.transform = 'translateY(0)';
    document.body.style.overflow = 'hidden';
    setTimeout(() => overlay.querySelector('.email-input')?.focus(), 350);
  };

  window.closeSignupModal = function(e) {
    // If called from overlay click, only close if clicking the overlay itself
    if (e && e.currentTarget === e.target) {
      // clicked overlay background
    } else if (e && e.target) {
      return; // clicked something inside modal
    }
    const overlay = document.getElementById('signup-modal');
    const inner   = document.getElementById('signup-modal-inner');
    if (!overlay) return;
    overlay.classList.remove('open');
    if (inner) inner.style.transform = 'translateY(20px)';
    document.body.style.overflow = '';
  };

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      const overlay = document.getElementById('signup-modal');
      const inner   = document.getElementById('signup-modal-inner');
      if (overlay) { overlay.classList.remove('open'); document.body.style.overflow = ''; }
      if (inner) inner.style.transform = 'translateY(20px)';
    }
  });

  // Auto-open modal after 20s for first-time visitors
  if (!localStorage.getItem('lull_signup_seen')) {
    setTimeout(() => {
      const overlay = document.getElementById('signup-modal');
      if (overlay && !overlay.classList.contains('open')) openSignupModal();
    }, 20000);
  }

  // ── EMAIL FORM SUBMISSIONS (AJAX) ────────────────────────
  // Submits to Shopify /contact via fetch so page doesn't reload

  async function submitContactForm(form, successId) {
    const email = form.querySelector('input[type="email"]').value.trim();
    if (!email || !email.includes('@')) return;

    try {
      const formData = new FormData(form);
      await fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData).toString()
      });
    } catch(err) {
      // Continue to show success even if fetch fails — Shopify may block CORS
      // but the data likely still went through
    }

    // Show success
    const successEl = document.getElementById(successId);
    if (successEl) successEl.style.display = 'block';
    form.querySelector('input[type="email"]').value = '';
    localStorage.setItem('lull_signup_seen', '1');
    showNotification('✓ You\'re on the list — see you at launch!');
  }

  window.handleProductSignup = function(e, form) {
    e.preventDefault();
    submitContactForm(form, 'product-signup-success');
  };

  window.handleModalSignup = function(e, form) {
    e.preventDefault();
    submitContactForm(form, 'modal-signup-success').then(() => {
      setTimeout(() => {
        const overlay = document.getElementById('signup-modal');
        const inner   = document.getElementById('signup-modal-inner');
        if (overlay) { overlay.classList.remove('open'); document.body.style.overflow = ''; }
        if (inner) inner.style.transform = 'translateY(20px)';
      }, 2200);
    });
  };

  window.handleCtaSignup = function(e, form) {
    e.preventDefault();
    submitContactForm(form, 'cta-signup-success');
  };

});
